import TagManager from 'react-gtm-module';
import { isProduction, isStageTwo, isStaging } from 'utils/environment';
import { removeSearchParam } from 'utils/update-query-params';
import { isClientSide } from 'utils/host-config';

import type { NextWebVitalsMetric } from 'next/app';

export const GTM_ENABLED = (isProduction || isStaging || isStageTwo) && isClientSide();

export const GTM_EVENT_PAGEVIEW = 'Pageview' as const;
export const GTM_EVENT_DELAYED_PAGEVIEW = 'delayed-pageview' as const;
export const GTM_EVENT_OFF_MARKET_PAGEVIEW = 'off-market-pageview' as const;
export const GTM_EVENT_WEB_VITALS_CATEGORY = 'Web Vitals' as const;
export const GTM_EVENT_APP_LOADED = 'app-loaded' as const;
export const GTM_EVENT_EXPERIMENT_VIEWED = 'experiment_viewed' as const;
export const GTM_EVENT_EXPERIMENT_CATEGORY = 'experiment' as const;

export function trackCurrentPageView(url: string) {
  if (!GTM_ENABLED || !url) return;

  const location = new URL(url, window.location.origin);
  const pixelPagePath = removeSearchParam(removeSearchParam(location.href, 'latitude'), 'longitude');

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_PAGEVIEW,
      pagePath: location.pathname,
      pixelPagePath,
    },
  });
}

export function trackDelayedPageView() {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_DELAYED_PAGEVIEW,
      pagePath: window.location.pathname,
    },
  });
}

export function trackConnectionRequest() {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_PAGEVIEW,
      pagePath: '/connection-request-submission',
    },
  });
}

export function trackOffMarketPage() {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_OFF_MARKET_PAGEVIEW,
      pagePath: window.location.pathname,
    },
  });
}

export function trackWebVitals(name: `web-vitals-${NextWebVitalsMetric['name']}`, value: number) {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: name,
      category: GTM_EVENT_WEB_VITALS_CATEGORY,
      pagePath: window.location.pathname,
      value: value,
    },
  });
}

export function trackEvent(event: string, category = 'All', label?: string, value?: number) {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({ dataLayer: { event, category, label, value }});
}

export function trackGrowthbookEvent(experimentId: string, variationId: number) {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_EXPERIMENT_VIEWED,
      event_category: GTM_EVENT_EXPERIMENT_CATEGORY,
      experiment_id: experimentId,
      variation_id: variationId,
    },
  });
}

export function trackAppLoadedEvent() {
  if (!GTM_ENABLED) return;

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_EVENT_APP_LOADED,
    },
  });
}